import classNames from 'classnames';
import React, { forwardRef, useState } from 'react';
export const TxInput = forwardRef((props, ref) => {
    const { label, errorMessage, hintMessage, className = '', hideLabel = false, required, type = 'text', onFocus, onBlur, optionalText = 'Optional', icon, ...inputProps } = props;
    const [showHint, setShowHint] = useState(false);
    function onFocusInternal(e) {
        if (hintMessage) {
            setShowHint(true);
        }
        if (onFocus) {
            onFocus(e);
        }
    }
    function onBlurInternal(e) {
        setShowHint(false);
        if (onBlur) {
            onBlur(e);
        }
    }
    return (React.createElement("div", { className: classNames('tx-input', { 'tx-input--icon': !!icon }, className) },
        React.createElement("label", { className: "tx-input__label" },
            React.createElement("span", { className: classNames('tx-input__label__text', {
                    'sr-only': hideLabel,
                    'tx-input__label__text__error': errorMessage,
                }) },
                label,
                !required && React.createElement("span", { className: "tx-input__label__text__optional" }, optionalText)),
            React.createElement("input", { className: classNames('tx-input__label__input', {
                    'tx-input__label__input--error': errorMessage,
                    'tx-input__label__input--hint': showHint,
                }), required: required, type: type, ref: ref, onFocus: onFocusInternal, onBlur: onBlurInternal, ...inputProps }),
            icon && React.createElement("div", { className: "tx-input__label__icon" }, icon)),
        errorMessage && (React.createElement("div", { className: "tx-input__error-message", "data-testid": "error-msg" }, errorMessage)),
        hintMessage && !errorMessage && showHint && (React.createElement("div", { className: "tx-input__hint-message", "data-testid": "hint-msg" }, hintMessage))));
});
//# sourceMappingURL=Input.js.map